/**
 * Given a list of errors it returns the error of a specific node field
 * @param {*} errors List of node errors
 * @param {*} field Node Prop to get the error for
 * @returns A String with the error message or null if there is no error.
 */
export function getFieldError(errors, field) {
  return errors && errors.length ? errors.find((e) => e.propertyName === field) : null;
}

/**
 * Given a node Prop field it returns which form field it should have to make it look good
 * @param {*} field Node prop name
 * @returns string containing the css class this prop should use
 */
export function getFieldSize(field) {
  const fullWidthFields = [
    'callPlanId',
    'whisper',
    'URL',
    'url',
    'text',
    'menuTagName',
    'credentials',
    'message',
    'emailNotification',
    'playBeep',
    'authorization',
    'advanced',
    'count',
    'pixelBody',
    'integrationMethod',
    'language',
    'voice',
  ];
  return (fullWidthFields.includes(field)) ? 'col-md-12' : 'col-md-6';
}

/**
 * Recursive method that runs through the node parameters and extracts the settings prop
 * @param {*} node Node to extract the settings prop from
 * @param {*} childFn function to use to extract the settings from
 * @param {*} parentN object containing the extracted settings
 * @param {*} parameterValue
 * @returns object with the node settings
 */
export function createSettingsHierarchy(node, childFn = n => n.parameters, parentN = {}, parameterValue) {
  const n = (typeof node.name !== 'undefined') ? node.name : 'root';
  const settings = n === 'root' ? parameterValue : parameterValue?.[n];

  const children = childFn(node);

  if (node.type === 'string') {
    parentN[n] = '';
  } else {
    parentN[n] = null;
  }

  if (n === 'URL') {
    parentN['groupMessage'] = 'Message';
  }

  if (children) {
    parentN[n] = {
      isEnabled: settings != null,
    };

    children.forEach(c => {
      createSettingsHierarchy(c, childFn, parentN[n], settings);
    });
  } else if ((node.type === 'bool' || node.type === 'list') && settings == null) {
    parentN[n] = node.defaultValue;
  }

  return parentN;
}

/**
 * Fields that should be labeled as code but are still coming as text on the backend
 */
export const codeFormattedFields = [
  'pixelBody'
];


/**
 * Returns a valid step name if provided;
 * otherwise, falls back to the node name with the last 4 characters of the node ID.
 */

export function getNodeStepName(node) {
  const { stepName, displayName, id } = node || {};

  const trimmedStepName = stepName?.trim();
  const fallbackDisplayName = displayName?.trim() || 'Node';
  const fallbackStepName = `${fallbackDisplayName} (${id?.slice(-4) || ''})`;

  return trimmedStepName ? trimmedStepName : fallbackStepName;
}
